import React from "react";
import DomainNameCard from "./DomainNameCard";
import { CardTypes } from "./domainNameCardService";

function DomainNameCardModal({ handleClose, cardType, domainId, domain }) {
    const isCreateMode = cardType === CardTypes.CREATE;

    return (
        <div className="modal oct_display-block modal-v2-root oct_settings-edit-modal">
            <div className="modal fade oct_modal show modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog oct_settings-modal-dialog oct_settings-modal-dialog--compact" aria-modal="true">
                    <div className="modal-content modal-v2-shell oct_settings-modal-shell">
                        <div className="modal-v2-header oct_settings-modal-header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading oct_settings-modal-heading">
                                        {isCreateMode ? "Create Domain" : "Edit Domain"}
                                    </h2>
                                    <p className="modal-v2-subheading oct_settings-modal-subheading">
                                        {isCreateMode
                                            ? "Add a domain and KDC pair for the system settings table."
                                            : "Update the selected domain entry and keep the system settings data in sync."}
                                    </p>
                                </div>
                                <button type="button" className="close modal-v2-close" aria-label="Close" onClick={handleClose}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>

                        <DomainNameCard handleClose={handleClose} cardType={cardType} domainId={domainId} domain={domain} />
                    </div>
                </div>
            </div>
        </div>
    )

}


export default DomainNameCardModal;
